import React from 'react';

const sectionStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	minHeight: '100%',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'start',
};

const SectionContainer = ({ style, children, Navigation }) => {
	return (
		<section style={{ ...sectionStyle, ...style }}>
			{children}
			{Navigation}
		</section>
	);
};

export default SectionContainer;
